import { Card } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${spacings.MEDIUM};
  padding: ${spacings.LARGE};
  border: 1px solid ${theme.light.ui.background.medium};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacings.MEDIUM};
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.SMALL};
`;

export const ProgressInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacings.MEDIUM};
`;
